// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Container ─────────────────────────────────────────────────────────── */
.epx-dmn-props,
.epx-dmn-props__empty {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: var(--epx-dmn-panel-text);
  padding: 16px 18px 24px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  background: var(--epx-dmn-panel-bg);
}

/* ── Empty state ───────────────────────────────────────────────────────── */
.epx-dmn-props__empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--epx-dmn-panel-text-muted);
  background: var(--epx-dmn-panel-bg);
  gap: 6px;
}
.epx-dmn-props__empty-icon {
  color: var(--epx-dmn-panel-text-faint);
  margin-bottom: 4px;
}
.epx-dmn-props__empty-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-props__empty-body {
  font-size: 12px;
  color: var(--epx-dmn-panel-text-muted);
}

/* ── Header ────────────────────────────────────────────────────────────── */
.epx-dmn-props__header {
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 18px;
}
.epx-dmn-props__header-top {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.epx-dmn-props__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--epx-dmn-panel-text);
  line-height: 1.25;
  word-break: break-word;
}
.epx-dmn-props__title--placeholder {
  color: var(--epx-dmn-panel-text-faint);
  font-style: italic;
  font-weight: 500;
}

.epx-dmn-props__kind-chip {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid transparent;
}
.epx-dmn-props__kind-chip--decision {
  background: var(--epx-dmn-decision-fill);
  color: var(--epx-dmn-decision-stroke);
  border-color: rgba(24, 144, 255, 0.25);
}
.epx-dmn-props__kind-chip--bkm {
  background: var(--epx-dmn-bkm-fill);
  color: var(--epx-dmn-bkm-stroke);
  border-color: rgba(114, 46, 209, 0.22);
}
.epx-dmn-props__kind-chip--input {
  background: var(--epx-dmn-input-fill);
  color: var(--epx-dmn-input-stroke);
  border-color: rgba(19, 194, 194, 0.25);
}
.epx-dmn-props__kind-chip--ks {
  background: var(--epx-dmn-ks-fill);
  color: var(--epx-dmn-ks-stroke);
  border-color: rgba(212, 136, 6, 0.25);
}
.epx-dmn-props__kind-chip--service {
  background: #eef2ff;
  color: #4338ca;
  border-color: rgba(67, 56, 202, 0.18);
}
.epx-dmn-props__kind-chip--requirement {
  background: var(--epx-dmn-grid-header-bg);
  color: var(--epx-dmn-panel-text-muted);
  border-color: var(--epx-dmn-panel-border);
}
.epx-dmn-props__kind-chip--other {
  background: var(--epx-dmn-grid-header-bg);
  color: var(--epx-dmn-panel-text-muted);
  border-color: var(--epx-dmn-panel-border);
}

.epx-dmn-props__id {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 2px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 11px;
  color: var(--epx-dmn-panel-text-faint);
}
.epx-dmn-props__id-label {
  font-weight: 600;
  color: var(--epx-dmn-panel-text-faint);
  letter-spacing: 0.06em;
}
.epx-dmn-props__id-value {
  user-select: all;
  color: var(--epx-dmn-panel-text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Groups ────────────────────────────────────────────────────────────── */
.epx-dmn-props__group { margin-bottom: 22px; }
.epx-dmn-props__group:last-child { margin-bottom: 0; }
.epx-dmn-props__group-header {
  text-transform: uppercase;
  font-size: 10.5px;
  letter-spacing: 0.08em;
  color: var(--epx-dmn-panel-text-muted);
  font-weight: 600;
  margin-bottom: 10px;
}

/* ── Fields ────────────────────────────────────────────────────────────── */
.epx-dmn-props__field {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}
.epx-dmn-props__field:last-child { margin-bottom: 0; }

.epx-dmn-props__label {
  font-size: 11px;
  font-weight: 500;
  color: var(--epx-dmn-panel-text-muted);
  margin-bottom: 5px;
  letter-spacing: 0.01em;
}

.epx-dmn-props__input,
.epx-dmn-props__textarea,
.epx-dmn-props__select {
  font-family: inherit;
  font-size: 13px;
  padding: 7px 10px;
  border: 1px solid var(--epx-dmn-input-border);
  border-radius: 6px;
  background: var(--epx-dmn-input-bg);
  color: var(--epx-dmn-panel-text);
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}
.epx-dmn-props__input { height: 32px; }
.epx-dmn-props__select { height: 32px; }
.epx-dmn-props__textarea {
  resize: vertical;
  min-height: 60px;
  line-height: 1.45;
}

.epx-dmn-props__input:hover,
.epx-dmn-props__textarea:hover,
.epx-dmn-props__select:hover {
  border-color: #94a3b8;
}
.epx-dmn-props__input:focus,
.epx-dmn-props__textarea:focus,
.epx-dmn-props__select:focus {
  outline: none;
  border-color: var(--epx-dmn-accent);
  box-shadow: 0 0 0 3px var(--epx-dmn-accent-alpha);
}

.epx-dmn-props__select--compact {
  width: auto;
  min-width: 96px;
  height: 28px;
  padding: 4px 8px;
  font-size: 12px;
}

.epx-dmn-props__readonly {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  padding: 6px 10px;
  color: var(--epx-dmn-panel-text-muted);
  background: var(--epx-dmn-grid-header-bg);
  border: 1px solid var(--epx-dmn-panel-border);
  border-radius: 6px;
  display: inline-block;
  word-break: break-all;
}

.epx-dmn-props__badge {
  display: inline-block;
  padding: 3px 10px;
  background: var(--epx-dmn-accent-bg);
  color: var(--epx-dmn-accent);
  border: 1px solid var(--epx-dmn-accent-border);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  width: fit-content;
}

.epx-dmn-props__button {
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 12px;
  border: 1px solid var(--epx-dmn-accent);
  background: var(--epx-dmn-accent-bg);
  color: var(--epx-dmn-accent);
  border-radius: 6px;
  cursor: pointer;
  transition: filter 0.12s ease;
}
.epx-dmn-props__button:hover { filter: brightness(0.96); }

.epx-dmn-props__hint {
  font-size: 11.5px;
  color: var(--epx-dmn-panel-text-muted);
  margin-top: 6px;
  line-height: 1.4;
}

/* ── Variable sync row ────────────────────────────────────────────────── */
.epx-dmn-props__sync-row {
  margin: -6px 0 12px;
}
.epx-dmn-props__sync-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  padding: 2px 4px;
  margin-left: -4px;
  font-family: inherit;
  font-size: 11.5px;
  color: var(--epx-dmn-accent);
  cursor: pointer;
  border-radius: 4px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.epx-dmn-props__sync-link:hover {
  background: var(--epx-dmn-accent-bg);
  color: var(--epx-dmn-accent-hover);
}
.epx-dmn-props__sync-link--unlinked {
  color: var(--epx-dmn-warning-dark);
}
.epx-dmn-props__sync-link--unlinked:hover {
  background: var(--epx-dmn-warning-soft);
  color: var(--epx-dmn-warning-dark);
}
.epx-dmn-props__sync-icon {
  font-size: 12px;
  line-height: 1;
}
.epx-dmn-props__sync-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.epx-dmn-props__sync-label code {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 11.5px;
  background: rgba(0, 0, 0, 0.04);
  padding: 1px 5px;
  border-radius: 3px;
  color: var(--epx-dmn-panel-text);
}

/* ── Parameters editor (BKM) ──────────────────────────────────────────── */
.epx-dmn-props__params { margin-bottom: 4px; }
.epx-dmn-props__params-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}
.epx-dmn-props__params-row {
  display: grid;
  grid-template-columns: 1fr 120px 28px;
  gap: 6px;
  align-items: center;
}
.epx-dmn-props__params-remove {
  width: 26px;
  height: 26px;
  line-height: 18px;
  border: 1px solid var(--epx-dmn-panel-border);
  background: transparent;
  color: var(--epx-dmn-panel-text-muted);
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  transition: border-color 0.12s ease, color 0.12s ease;
}
.epx-dmn-props__params-remove:hover {
  border-color: var(--epx-dmn-danger);
  color: var(--epx-dmn-danger);
}

/* ── Inputs group (Decision/BKM) ──────────────────────────────────────── */
.epx-dmn-props__inputs-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  margin-bottom: 4px;
  background: #f6f8fa;
  border: 1px solid transparent;
  border-radius: 6px;
}
.epx-dmn-props__inputs-row:last-child { margin-bottom: 0; }
.epx-dmn-props__inputs-row--orphan {
  background: var(--epx-dmn-warning-soft);
  border-left: 3px solid var(--epx-dmn-warning);
  padding-left: 8px;
}
.epx-dmn-props__inputs-name {
  flex: 1;
  font-size: 12.5px;
  color: var(--epx-dmn-panel-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.epx-dmn-props__inputs-row--orphan .epx-dmn-props__inputs-name {
  color: var(--epx-dmn-warning-dark);
}
.epx-dmn-props__inputs-promote {
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: var(--epx-dmn-accent);
  padding: 0 4px;
}
.epx-dmn-props__inputs-promote:hover { color: var(--epx-dmn-accent-hover); }
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/properties/styles.css"],"names":[],"mappings":"AAEA,6EAA6E;AAC7E;;EAEE,0GAA0G;EAC1G,eAAe;EACf,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,mCAAmC;AACrC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,QAAQ;AACV;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,4EAA4E;EAC5E,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E,wBAAwB,mBAAmB,EAAE;AAC7C,mCAAmC,gBAAgB,EAAE;AACrD;EACE,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA,mCAAmC,gBAAgB,EAAE;;AAErD;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;EAGE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,0DAA0D;AAC5D;AACA,wBAAwB,YAAY,EAAE;AACtC,yBAAyB,YAAY,EAAE;AACvC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,aAAa;EACb,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4EAA4E;EAC5E,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,yCAAyC;EACzC,6CAA6C;EAC7C,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;EACpC,4BAA4B;EAC5B,8CAA8C;EAC9C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA,+BAA+B,wBAAwB,EAAE;;AAEzD;EACE,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4EAA4E;EAC5E,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,4EAA4E;AAC5E,yBAAyB,kBAAkB,EAAE;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;EAC7C,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,UAAU;EACV,qDAAqD;AACvD;AACA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA,wCAAwC,gBAAgB,EAAE;AAC1D;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;AACA,uCAAuC,kCAAkC,EAAE","sourcesContent":["@import url('../theme.css');\n\n/* ── Container ─────────────────────────────────────────────────────────── */\n.epx-dmn-props,\n.epx-dmn-props__empty {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  color: var(--epx-dmn-panel-text);\n  padding: 16px 18px 24px;\n  height: 100%;\n  box-sizing: border-box;\n  overflow: auto;\n  background: var(--epx-dmn-panel-bg);\n}\n\n/* ── Empty state ───────────────────────────────────────────────────────── */\n.epx-dmn-props__empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: var(--epx-dmn-panel-text-muted);\n  background: var(--epx-dmn-panel-bg);\n  gap: 6px;\n}\n.epx-dmn-props__empty-icon {\n  color: var(--epx-dmn-panel-text-faint);\n  margin-bottom: 4px;\n}\n.epx-dmn-props__empty-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-props__empty-body {\n  font-size: 12px;\n  color: var(--epx-dmn-panel-text-muted);\n}\n\n/* ── Header ────────────────────────────────────────────────────────────── */\n.epx-dmn-props__header {\n  padding-bottom: 14px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  margin-bottom: 18px;\n}\n.epx-dmn-props__header-top {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.epx-dmn-props__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--epx-dmn-panel-text);\n  line-height: 1.25;\n  word-break: break-word;\n}\n.epx-dmn-props__title--placeholder {\n  color: var(--epx-dmn-panel-text-faint);\n  font-style: italic;\n  font-weight: 500;\n}\n\n.epx-dmn-props__kind-chip {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  border: 1px solid transparent;\n}\n.epx-dmn-props__kind-chip--decision {\n  background: var(--epx-dmn-decision-fill);\n  color: var(--epx-dmn-decision-stroke);\n  border-color: rgba(24, 144, 255, 0.25);\n}\n.epx-dmn-props__kind-chip--bkm {\n  background: var(--epx-dmn-bkm-fill);\n  color: var(--epx-dmn-bkm-stroke);\n  border-color: rgba(114, 46, 209, 0.22);\n}\n.epx-dmn-props__kind-chip--input {\n  background: var(--epx-dmn-input-fill);\n  color: var(--epx-dmn-input-stroke);\n  border-color: rgba(19, 194, 194, 0.25);\n}\n.epx-dmn-props__kind-chip--ks {\n  background: var(--epx-dmn-ks-fill);\n  color: var(--epx-dmn-ks-stroke);\n  border-color: rgba(212, 136, 6, 0.25);\n}\n.epx-dmn-props__kind-chip--service {\n  background: #eef2ff;\n  color: #4338ca;\n  border-color: rgba(67, 56, 202, 0.18);\n}\n.epx-dmn-props__kind-chip--requirement {\n  background: var(--epx-dmn-grid-header-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  border-color: var(--epx-dmn-panel-border);\n}\n.epx-dmn-props__kind-chip--other {\n  background: var(--epx-dmn-grid-header-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  border-color: var(--epx-dmn-panel-border);\n}\n\n.epx-dmn-props__id {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin-top: 2px;\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 11px;\n  color: var(--epx-dmn-panel-text-faint);\n}\n.epx-dmn-props__id-label {\n  font-weight: 600;\n  color: var(--epx-dmn-panel-text-faint);\n  letter-spacing: 0.06em;\n}\n.epx-dmn-props__id-value {\n  user-select: all;\n  color: var(--epx-dmn-panel-text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Groups ────────────────────────────────────────────────────────────── */\n.epx-dmn-props__group { margin-bottom: 22px; }\n.epx-dmn-props__group:last-child { margin-bottom: 0; }\n.epx-dmn-props__group-header {\n  text-transform: uppercase;\n  font-size: 10.5px;\n  letter-spacing: 0.08em;\n  color: var(--epx-dmn-panel-text-muted);\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n/* ── Fields ────────────────────────────────────────────────────────────── */\n.epx-dmn-props__field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 12px;\n}\n.epx-dmn-props__field:last-child { margin-bottom: 0; }\n\n.epx-dmn-props__label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--epx-dmn-panel-text-muted);\n  margin-bottom: 5px;\n  letter-spacing: 0.01em;\n}\n\n.epx-dmn-props__input,\n.epx-dmn-props__textarea,\n.epx-dmn-props__select {\n  font-family: inherit;\n  font-size: 13px;\n  padding: 7px 10px;\n  border: 1px solid var(--epx-dmn-input-border);\n  border-radius: 6px;\n  background: var(--epx-dmn-input-bg);\n  color: var(--epx-dmn-panel-text);\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n.epx-dmn-props__input { height: 32px; }\n.epx-dmn-props__select { height: 32px; }\n.epx-dmn-props__textarea {\n  resize: vertical;\n  min-height: 60px;\n  line-height: 1.45;\n}\n\n.epx-dmn-props__input:hover,\n.epx-dmn-props__textarea:hover,\n.epx-dmn-props__select:hover {\n  border-color: #94a3b8;\n}\n.epx-dmn-props__input:focus,\n.epx-dmn-props__textarea:focus,\n.epx-dmn-props__select:focus {\n  outline: none;\n  border-color: var(--epx-dmn-accent);\n  box-shadow: 0 0 0 3px var(--epx-dmn-accent-alpha);\n}\n\n.epx-dmn-props__select--compact {\n  width: auto;\n  min-width: 96px;\n  height: 28px;\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n.epx-dmn-props__readonly {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 12px;\n  padding: 6px 10px;\n  color: var(--epx-dmn-panel-text-muted);\n  background: var(--epx-dmn-grid-header-bg);\n  border: 1px solid var(--epx-dmn-panel-border);\n  border-radius: 6px;\n  display: inline-block;\n  word-break: break-all;\n}\n\n.epx-dmn-props__badge {\n  display: inline-block;\n  padding: 3px 10px;\n  background: var(--epx-dmn-accent-bg);\n  color: var(--epx-dmn-accent);\n  border: 1px solid var(--epx-dmn-accent-border);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 500;\n  width: fit-content;\n}\n\n.epx-dmn-props__button {\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 6px 12px;\n  border: 1px solid var(--epx-dmn-accent);\n  background: var(--epx-dmn-accent-bg);\n  color: var(--epx-dmn-accent);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: filter 0.12s ease;\n}\n.epx-dmn-props__button:hover { filter: brightness(0.96); }\n\n.epx-dmn-props__hint {\n  font-size: 11.5px;\n  color: var(--epx-dmn-panel-text-muted);\n  margin-top: 6px;\n  line-height: 1.4;\n}\n\n/* ── Variable sync row ────────────────────────────────────────────────── */\n.epx-dmn-props__sync-row {\n  margin: -6px 0 12px;\n}\n.epx-dmn-props__sync-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  padding: 2px 4px;\n  margin-left: -4px;\n  font-family: inherit;\n  font-size: 11.5px;\n  color: var(--epx-dmn-accent);\n  cursor: pointer;\n  border-radius: 4px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.epx-dmn-props__sync-link:hover {\n  background: var(--epx-dmn-accent-bg);\n  color: var(--epx-dmn-accent-hover);\n}\n.epx-dmn-props__sync-link--unlinked {\n  color: var(--epx-dmn-warning-dark);\n}\n.epx-dmn-props__sync-link--unlinked:hover {\n  background: var(--epx-dmn-warning-soft);\n  color: var(--epx-dmn-warning-dark);\n}\n.epx-dmn-props__sync-icon {\n  font-size: 12px;\n  line-height: 1;\n}\n.epx-dmn-props__sync-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.epx-dmn-props__sync-label code {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 11.5px;\n  background: rgba(0, 0, 0, 0.04);\n  padding: 1px 5px;\n  border-radius: 3px;\n  color: var(--epx-dmn-panel-text);\n}\n\n/* ── Parameters editor (BKM) ──────────────────────────────────────────── */\n.epx-dmn-props__params { margin-bottom: 4px; }\n.epx-dmn-props__params-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n.epx-dmn-props__params-row {\n  display: grid;\n  grid-template-columns: 1fr 120px 28px;\n  gap: 6px;\n  align-items: center;\n}\n.epx-dmn-props__params-remove {\n  width: 26px;\n  height: 26px;\n  line-height: 18px;\n  border: 1px solid var(--epx-dmn-panel-border);\n  background: transparent;\n  color: var(--epx-dmn-panel-text-muted);\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  transition: border-color 0.12s ease, color 0.12s ease;\n}\n.epx-dmn-props__params-remove:hover {\n  border-color: var(--epx-dmn-danger);\n  color: var(--epx-dmn-danger);\n}\n\n/* ── Inputs group (Decision/BKM) ──────────────────────────────────────── */\n.epx-dmn-props__inputs-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  margin-bottom: 4px;\n  background: #f6f8fa;\n  border: 1px solid transparent;\n  border-radius: 6px;\n}\n.epx-dmn-props__inputs-row:last-child { margin-bottom: 0; }\n.epx-dmn-props__inputs-row--orphan {\n  background: var(--epx-dmn-warning-soft);\n  border-left: 3px solid var(--epx-dmn-warning);\n  padding-left: 8px;\n}\n.epx-dmn-props__inputs-name {\n  flex: 1;\n  font-size: 12.5px;\n  color: var(--epx-dmn-panel-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.epx-dmn-props__inputs-row--orphan .epx-dmn-props__inputs-name {\n  color: var(--epx-dmn-warning-dark);\n}\n.epx-dmn-props__inputs-promote {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  color: var(--epx-dmn-accent);\n  padding: 0 4px;\n}\n.epx-dmn-props__inputs-promote:hover { color: var(--epx-dmn-accent-hover); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
